<!--
  Reiner Tabellen-INHALT (ohne Overlay-Chrome) - wiederverwendbar sowohl in StandingsOverlay.vue
  (eigenständiges Tabellen-Overlay, per Tabelle-Button auf der Match-Karte) als auch im neuen
  "tabelle"-Tab in DetailOverlay.vue, damit beide Stellen exakt gleich aussehen.
-->
<template>
  <div ref="wurzel">
    <div v-if="bloecke.length === 0" class="tm-state">Keine Tabelle verfügbar.</div>

    <div v-for="block in bloecke" :key="block.gruppe ?? 'block'" class="tm-tabelle-block">
      <h4 v-if="block.gruppe && bloecke.length > 1" class="tm-tabelle__gruppentitel">{{ block.gruppe }}</h4>

      <div class="tm-tabelle">
        <div class="tm-tabelle__kopfzeile">
          <div class="tm-tabelle__namenzeile">
            <span class="tm-tabelle__rang"></span>
            <span class="tm-tabelle__logo-platz"></span>
            <span class="tm-tabelle__name"></span>
          </div>
          <div class="tm-tabelle__zahlenzeile">
            <span class="tm-tabelle__zahl">Sp</span>
            <span class="tm-tabelle__zahl">S</span>
            <span class="tm-tabelle__zahl">U</span>
            <span class="tm-tabelle__zahl">N</span>
            <span class="tm-tabelle__zahl">Tore</span>
            <span class="tm-tabelle__zahl">Diff</span>
            <span class="tm-tabelle__zahl tm-tabelle__zahl--punkte">Pkt</span>
          </div>
        </div>

        <div
          v-for="eintrag in block.eintraege"
          :key="eintrag.team?.id"
          :class="['tm-tabelle__zeile', { 'tm-tabelle__zeile--hervorgehoben': istHervorgehoben(eintrag.team?.id) }]"
        >
          <div class="tm-tabelle__namenzeile">
            <span class="tm-tabelle__rang">{{ eintrag.rank }}</span>
            <span class="tm-tabelle__logo-platz">
              <img v-if="eintrag.team?.logo" :src="eintrag.team.logo" alt="" />
            </span>
            <span class="tm-tabelle__name">{{ eintrag.team?.name }}</span>
          </div>
          <div class="tm-tabelle__zahlenzeile">
            <span class="tm-tabelle__zahl">{{ eintrag.all?.played }}</span>
            <span class="tm-tabelle__zahl">{{ eintrag.all?.win }}</span>
            <span class="tm-tabelle__zahl">{{ eintrag.all?.draw }}</span>
            <span class="tm-tabelle__zahl">{{ eintrag.all?.lose }}</span>
            <span class="tm-tabelle__zahl">{{ eintrag.all?.goals?.for }}:{{ eintrag.all?.goals?.against }}</span>
            <span class="tm-tabelle__zahl">{{ torDifferenz(eintrag) }}</span>
            <span class="tm-tabelle__zahl tm-tabelle__zahl--punkte">{{ eintrag.points }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { nextTick, ref, watch } from 'vue'
import { tabelleFuerLiga } from '../lib/standings.js'

const props = defineProps({
  tabellen: { type: Array, required: true },
  match: { type: Object, required: true }
})

const wurzel = ref(null)

const bloecke = computed(() =>
  tabelleFuerLiga(props.tabellen, props.match.ligaId).map(block => ({
    gruppe: block.standings?.[0]?.group?.trim() || null,
    eintraege: [...(block.standings ?? [])].sort((a, b) => a.rank - b.rank)
  }))
)

function istHervorgehoben(teamId) {
  return teamId === props.match.heimId || teamId === props.match.auswaertsId
}

function torDifferenz(eintrag) {
  const f = eintrag.all?.goals?.for
  const a = eintrag.all?.goals?.against
  if (typeof f !== 'number' || typeof a !== 'number') return '–'
  const diff = f - a
  return diff > 0 ? `+${diff}` : String(diff)
}

function findeScrollbarenVorfahren(el) {
  let node = el?.parentElement
  while (node) {
    const style = getComputedStyle(node)
    const kannScrollenY = /(auto|scroll)/.test(style.overflowY)
    if (kannScrollenY && node.scrollHeight > node.clientHeight) return node
    node = node.parentElement
  }
  return null
}

function scrolleZuHervorgehobenenZeilen() {
  if (!wurzel.value) return
  const zeile = wurzel.value.querySelector('.tm-tabelle__zeile--hervorgehoben')
  if (!zeile) return

  const container = findeScrollbarenVorfahren(zeile)
  if (!container) return // Tabelle passt komplett, nichts zu tun

  const containerRect = container.getBoundingClientRect()
  const zeileRect = zeile.getBoundingClientRect()

  const relativ = zeileRect.top - containerRect.top + container.scrollTop
  const zielScroll = relativ - container.clientHeight / 2 + zeile.offsetHeight / 2

  container.scrollTo({ top: Math.max(0, zielScroll), behavior: 'auto' })
}

// Tabellen kommen evtl. asynchron nach dem Mount an -> bei jeder Änderung neu scrollen
watch(bloecke, () => { nextTick(scrolleZuHervorgehobenenZeilen) }, { immediate: true, flush: 'post' })

</script>